import axios from "axios";
import storeService from "./../services/service.store";
import { removeAuthToken } from "./authToken";
import { SERVER_PATH } from "./../api/config";
import { API_LOGIN_INFORMATION, API_VERIFY_OTP, API_LOGOUT_INFORMATION } from "./../api";
// Create instance (same API base as src/api/index.js: local, rril or production by domain)
export const axiosConfig = axios.create({
    baseURL: SERVER_PATH
});

// Request interceptor: dynamically attach latest token
axiosConfig.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("_business_panel_token");
        if (!config.headers["Authorization"]) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor: auto logout when the session of a signed-in user is rejected (401).
// A 401 from the sign-in calls themselves (e.g. authenticate answers 401 "already logged in") or from logout
// is not an expired session, and must not start another logout. Only one automatic logout runs at a time.
const LOGOUT_EXEMPT_URLS = [API_LOGIN_INFORMATION, API_VERIFY_OTP, API_LOGOUT_INFORMATION];
let autoLogoutStarted = false;

axiosConfig.interceptors.response.use(
    (res) => res,
    (err) => {
        const requestUrl = err.config?.url || "";
        const isExempt = LOGOUT_EXEMPT_URLS.some((url) => requestUrl.includes(url.replace(SERVER_PATH, "")));

        if (err.response?.status === 401 && !isExempt && !autoLogoutStarted) {
            autoLogoutStarted = true;
            // logout reads the stored token to tell the server who is signing out, so it must start before the token is removed
            const loggingOut = Promise.resolve(storeService.logout());
            removeAuthToken(); // triggers useAuthWatcher logout
            loggingOut.catch(() => { });
        }
        return Promise.reject(err);
    }
);


export const getContentTypeLogin = () => ({
    "Authorization": `Bearer`,
    "Content-Type": "application/x-www-form-urlencoded"
});

export const getContentTypeDefault = () => {
    const token = localStorage.getItem("_business_panel_token");
    return {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded"
    };
};

export const getContentTypeNonBearer = () => {
    const token = localStorage.getItem("_business_panel_token");
    return {
        "Authorization": `${token}`,
        "Content-Type": "application/x-www-form-urlencoded"
    };
};

export const getContentTypeJson = () => {
    const token = localStorage.getItem("_business_panel_token");
    return {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
    };
};

export const getContentTypeBlobDefault = () => {
    const token = localStorage.getItem("_business_panel_token");
    return {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/vnd.ms-excel;charset=UTF-8"
    };
};


